import { JsonObject, JsonProperty } from 'json2typescript';
import { PerPersonnelModel } from './per-personnel-model';
import { PerIdentityModel } from '../../../model/per-identity-model';
import { HvlDateConverter } from '@hvlng/framework-bff/util';
import { EmptyControl, Nested } from '@hvlng/framework-bff/core';

@JsonObject('KovanHrPersonnelBasisInfoCardModel')
export class PersonnelBasisInfoCardModel {

    @Nested()
    @JsonProperty('personnel', PerPersonnelModel, true)
    personnel: PerPersonnelModel = new PerPersonnelModel();

    @Nested()
    @JsonProperty('identity', PerIdentityModel, true)
    identity: PerIdentityModel = new PerIdentityModel();

    @EmptyControl()
    @JsonProperty('startDate', HvlDateConverter, true)
    startDate: Date;

    @EmptyControl()
    @JsonProperty('lastEducationBranchOfStudyText', String, true)
    lastEducationBranchOfStudyText: string = null;

    @EmptyControl()
    @JsonProperty('lastEducationInstitutionText', String, true)
    lastEducationInstitutionText: string = null;

    @EmptyControl()
    @JsonProperty('lastEducationSchoolName', String, true)
    lastEducationSchoolName: string = null;

    @EmptyControl()
    @JsonProperty('lastEducationDepartmentName', String, true)
    lastEducationDepartmentName: string = null;
}
